import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Mod_parcialComponent = /** @class */ (function () {
    function Mod_parcialComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            supt_parcial: new FormControl(''),
            supm_parcial: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("mod_parcial"))) {
            localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("mod_parcial"));
            this.form.controls['supt_parcial'].setValue(this.rows[0] ? this.rows[0].supt_parcial : '');
            this.form.controls['supm_parcial'].setValue(this.rows[0] ? this.rows[0].supm_parcial : '');
        }
    }
    Mod_parcialComponent.prototype.add_mod_parcial = function () {
        localStorage.setItem("mod_parcial", JSON.stringify([]));
        this.actualRow = localStorage.getItem("mod_parcial");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            supt_parcial: this.form.value.supt_parcial,
            supm_parcial: this.form.value.supm_parcial
        });
        localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
    };
    Mod_parcialComponent.prototype.delete_mod_parcial = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
            }
        }
    };
    return Mod_parcialComponent;
}());
export { Mod_parcialComponent };
